"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOCTOR_AVAILABILITY_REQUEST_EXAMPLES = exports.availabilityOverrideRequestSchema = exports.doctorLeaveRequestSchema = exports.updateScheduleRequestSchema = exports.listDoctorSchedulesRequestSchema = exports.createScheduleRequestSchema = void 0;
/**
 * Request contracts for the 4 Doctor Availability endpoints named in
 * this stage's brief. Field shapes mirror
 * `DoctorAvailabilityApplicationService`'s own method input shapes
 * (backend, frozen, Stage 5B.4). `EmergencyAvailability` has no
 * contract yet — the brief names 4 items, not 5; see
 * `docs/APPOINTMENT-API-REVIEW.md`'s Technical Debt Register.
 */
const zod_1 = require("zod");
const appointment_common_request_1 = require("./appointment-common.request");
const scheduleSessionSchema = zod_1.z.object({
    dayOfWeek: zod_1.z.number().int().min(0).max(6),
    startTime: zod_1.z.string().regex(/^\d{2}:\d{2}$/, 'Expected HH:MM'),
    endTime: zod_1.z.string().regex(/^\d{2}:\d{2}$/, 'Expected HH:MM'),
    slotDurationMinutes: zod_1.z.number().int().positive().optional(),
    capacityPerSlot: zod_1.z.number().int().positive().optional(),
    sessionCategory: zod_1.z.enum(['GENERAL', 'EMERGENCY', 'TELEMEDICINE']).optional(),
    consultationModes: zod_1.z.array(zod_1.z.enum(['IN_PERSON', 'TELEMEDICINE', 'HOME_VISIT'])).optional(),
});
exports.createScheduleRequestSchema = zod_1.z.object({
    doctorId: zod_1.z.string().uuid(),
    departmentId: zod_1.z.string().uuid(),
    branchId: zod_1.z.string().uuid(),
    scheduleName: zod_1.z.string().min(1).max(255),
    effectiveFrom: zod_1.z.coerce.date(),
    effectiveTo: zod_1.z.coerce.date().optional(),
    sessions: zod_1.z.array(scheduleSessionSchema).min(1, 'A schedule must have at least one session'),
});
/** Query schema for `GET /doctor-schedule?doctorId=` — closes the real, disclosed gap that schedules could be created/updated but never browsed. */
exports.listDoctorSchedulesRequestSchema = zod_1.z.object({
    doctorId: zod_1.z.string().uuid(),
});
exports.updateScheduleRequestSchema = zod_1.z.object({
    scheduleId: zod_1.z.string().uuid(),
    scheduleName: zod_1.z.string().min(1).max(255).optional(),
    effectiveTo: zod_1.z.coerce.date().optional(),
    isActive: zod_1.z.boolean().optional(),
});
exports.doctorLeaveRequestSchema = zod_1.z.object({
    doctorId: zod_1.z.string().uuid(),
    leaveFrom: zod_1.z.coerce.date(),
    leaveTo: zod_1.z.coerce.date(),
    reasonCode: zod_1.z.string().max(100).optional(),
    reasonDescription: zod_1.z.string().optional(),
    approverNotification: appointment_common_request_1.notificationRequestSchema.optional(),
});
exports.availabilityOverrideRequestSchema = zod_1.z.object({
    doctorId: zod_1.z.string().uuid(),
    fromDateTime: zod_1.z.coerce.date(),
    toDateTime: zod_1.z.coerce.date(),
    overrideType: zod_1.z.enum(['BLOCKED', 'EXTRA_AVAILABLE']),
    blockCategory: zod_1.z.enum(['MAINTENANCE', 'EMERGENCY', 'VIP', 'GENERAL']).optional(),
    reasonCode: zod_1.z.string().max(100).optional(),
    reasonDescription: zod_1.z.string().optional(),
});
exports.DOCTOR_AVAILABILITY_REQUEST_EXAMPLES = {
    createSchedule: {
        doctorId: '22222222-2222-2222-2222-222222222222',
        departmentId: '44444444-4444-4444-4444-444444444444',
        branchId: '33333333-3333-3333-3333-333333333333',
        scheduleName: 'Dr. Rao — General OPD',
        effectiveFrom: new Date('2026-08-01'),
        sessions: [{ dayOfWeek: 1, startTime: '09:00', endTime: '13:00' }],
    },
    updateSchedule: {
        scheduleId: '70000000-0000-0000-0000-000000000001',
        isActive: false,
    },
    doctorLeave: {
        doctorId: '22222222-2222-2222-2222-222222222222',
        leaveFrom: new Date('2026-08-10'),
        leaveTo: new Date('2026-08-12'),
    },
    availabilityOverride: {
        doctorId: '22222222-2222-2222-2222-222222222222',
        fromDateTime: new Date('2026-08-01T13:00:00Z'),
        toDateTime: new Date('2026-08-01T14:00:00Z'),
        overrideType: 'BLOCKED',
        blockCategory: 'MAINTENANCE',
    },
};
//# sourceMappingURL=doctor-availability.request.js.map